export const textEditorInsertModalConsts = {
    linkMsg: 'Ссылка',
    linkTextMsg: 'Текст ссылки'
}
